<template>
  <div>
    <v-btn @click="showDialog = true" class="btnclean button-margin" >
      <v-icon>mdi-filter</v-icon>
    </v-btn>

    <v-dialog scrollable v-model="showDialog" :max-width="dialogWidth">
      <v-card>
        <v-card-title>
          <h3>Filtros</h3>
        </v-card-title>
        <v-card-text>
          <v-row class="content-container">
            <v-col cols="6">
              <v-autocomplete v-model="selectedColumn" label="Seleccionar Columna" item-text="title" item-value="name"
                :items="availableColumns" outlined dense />
            </v-col>
            <v-col cols="3">
              <v-btn class="btn-save" @click="handleColumn" :disabled="!this.selectedColumn">Añadir Columna</v-btn>
            </v-col>
            <v-col col="3" style="margin-bottom: 25px;">
              <v-btn class="btnclean" @click="selectedColumns = []">Quitar columnas</v-btn>
            </v-col>
          </v-row>
          <v-row v-for="(column, index) in selectedColumns" :key="index">
            <v-col cols="10">
              <template v-if="column.type == 'select'">
                <v-select v-model="column.value" :items="column.options" item-text="name" item-value="value"
                  @change="filterOptions(column)" outlined dense :label="column.title" />
              </template>
              <template v-else>
                <v-text-field v-model="column.value" outlined dense :label="column.title" />
              </template>
            </v-col>
            <v-col cols="2">
              <v-btn class="btndelete" @click="deleteColumn(column)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn class="btndelete" @click="showDialog = false">Cerrar</v-btn>
          <v-btn class="btn-save" @click="showDialog = false; filterOptions()">Filtrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'GeneralColumnFilter',
  props: {
    columns: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      showDialog: false,
      selectedColumn: null,
      selectedColumns: []
    };
  },
  computed: {
    dialogWidth() {
      return this.$vuetify.breakpoint.smAndDown ? "95%" : "40%";
    },
    availableColumns() {
      return this.columns.filter((column) => {
        return !this.selectedColumns.some((selectedColumn) => {
          return column.name === selectedColumn.name;
        });
      });
    },
  },
  methods: {
    handleColumn() {
      const selectedColumn = this.columns.find(
        (selectedColumn) => selectedColumn.name === this.selectedColumn
      )
      this.selectedColumns.push(selectedColumn)
      this.selectedColumn = null
    },
    filterOptions() {
      this.$emit('onColumns', this.selectedColumns)
    },
    deleteColumn(column) {
      this.selectedColumns = this.selectedColumns.filter(
        (selectedColumn) => selectedColumn.name !== column.name
      )
    }
  }
}
</script>

<style scoped>
.button-margin{
  margin-left: .5rem;
}
.content-container {
  padding-top: 1.5rem;
}
</style>